import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";

export const CloseIconContainer = styled.div(({ theme }) => ({
    position: "absolute",
    top: theme.spacing.medium,
    right: theme.spacing.medium,
    zIndex: 1,
    cursor: "pointer",
}));

export const FullWidthSuperButton = styled(SuperButton)({
    width: "100%",
    maxWidth: "100%",
});

export const ConfirmContainer = styled.div({
    display: "flex",
    flexDirection: "column",
});

export const ConfirmImageContainer = styled.div(() => ({
    overflow: "hidden",
}));

export const ConfirmTitle = styled(Text)({
    textAlign: "center",
});

export const ConfirmSubheading = styled(Text)({
    textAlign: "center",
});

export const ConfirmTitleContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: theme.spacing.medium,
}));

export const PickupPointCard = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing.medium,
    borderRadius: theme.cornerRadius.small,
    paddingTop: theme.spacing.xxSmall,
    textAlign: "center",
}));

export const PickupPointInfo = styled.div({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    textAlign: "left",
});

export const PickupPointInfoCenter = styled.div({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    textAlign: "center",
});

export const NearestBadge = styled(Text)(({ theme }) => ({
    display: "inline-flex",
    alignItems: "center",
    backgroundColor: theme.colors[theme.colorMode].background_Button_Secondary,
    color: theme.colors[theme.colorMode].warning,
    padding: `${theme.spacing.xxxSmall} ${theme.spacing.xSmall}`,
    borderRadius: theme.cornerRadius.halfRounded,
    marginLeft: theme.spacing.xSmall,
    fontSize: "10px",
    fontWeight: 600,
}));

export const NearestBadgeOrange = styled(Text)<{ isSelected: boolean }>(({ theme, isSelected }) => ({
    display: "inline-flex",
    alignItems: "center",
    backgroundColor: isSelected
        ? theme.colors[theme.colorMode].special_primary
        : theme.colors[theme.colorMode].background_Secondary,
    color: isSelected
        ? theme.colors[theme.colorMode].background_Primary
        : theme.colors[theme.colorMode].text_High_Emphasis,
    padding: `${theme.spacing.xxxSmall} ${theme.spacing.xSmall}`,
    borderRadius: theme.cornerRadius.halfRounded,
    marginLeft: theme.spacing.xSmall,
    fontSize: "10px",
    fontWeight: 600,
    alignSelf: "baseline",
    marginTop: "2px",
}));

export const PickupPointNameRow = styled.div({
    display: "flex",
    alignItems: "center",
    margin: "0 auto",
});

export const PickupPointNameRowLeft = styled.div({
    display: "flex",
    alignItems: "center",
});

export const ConfirmButtonContainer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.large,
    marginBottom: theme.spacing.large,
    gap: theme.spacing.small,
    display: "flex",
    padding: `0 ${theme.spacing.medium}`,
    "& > *": {
        flex: 1,
    },
}));

export const ChangePickupLink = styled(Text)(({ theme }) => ({
    cursor: "pointer",
    marginTop: theme.spacing.small,
    marginBottom: theme.spacing.large,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

export const RightChevronWrapper = styled.div(() => {
    return {
        marginTop: "1px",
        marginLeft: "2px",
    };
});

export const FooterText = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.large,
    textAlign: "center",
    paddingBottom: theme.spacing.medium,
}));

export const SelectContainer = styled.div({
    display: "flex",
    flexDirection: "column",
});

export const SelectTitle = styled(Text)(({ theme }) => ({
    textAlign: "center",
    padding: `0 ${theme.spacing.xLarge}`,
}));

export const SelectSubtitle = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.xxSmall,
}));

export const PickupPointsList = styled.div(({ theme }) => ({
    marginTop: theme.spacing.large,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.small,
    maxHeight: "30vh",
    overflowY: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
        display: "none",
    },
}));

export const PickupPointListItem = styled.button<{ $isSelected: boolean }>(({ theme, $isSelected }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing.medium,
    border: `1px solid ${$isSelected ? theme.colors[theme.colorMode].border_Selected : theme.colors[theme.colorMode].border_Tertiary}`,
    borderRadius: theme.cornerRadius.small,
    background: $isSelected
        ? theme.colors[theme.colorMode].background_Button_Secondary
        : theme.colors[theme.colorMode].background_Primary,
    cursor: "pointer",
    textAlign: "left",
    width: "100%",
}));

export const RadioCircle = styled.div<{ $isSelected: boolean }>(({ theme, $isSelected }) => ({
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    border: `1px solid ${$isSelected ? theme.colors[theme.colorMode].primary : theme.colors[theme.colorMode].border_Secondary}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "10px",
    flexShrink: 0,
    ...($isSelected && {
        "&::after": {
            content: '""',
            width: "12px",
            height: "12px",
            borderRadius: "50%",
            backgroundColor: theme.colors[theme.colorMode].primary,
        },
    }),
}));

export const SelectButtonContainer = styled.div(({ theme }) => ({
    boxShadow: "0 -4px 8px rgba(0, 0, 0, 0.08)",
    padding: `${theme.spacing.large} ${theme.spacing.medium}`,
}));

export const ContentContainer = styled.div(({ theme }) => ({
    padding: `${theme.spacing.xLarge} ${theme.spacing.medium} 0 ${theme.spacing.medium}`,
}));
